import {
  AdvanceExternalPaymentVerificationResult,
  AdvanceExternalPaymentVerificationResultTypenames,
} from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import { isExternalPaymentLinkCardType } from 'features/advance/helpers/Advance.helpers';
import { AdvanceExternalPaymentVerificationQuery } from 'services/graphql/queries/advance/AdvanceExternalPaymentVerification';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

export const useExternalPaymentVerification = ({
  amount,
  optionId,
}: {
  amount: string;
  optionId: string;
}) => {
  const router = useRouter();
  const [{ data, error, fetching }, refetch] = useQuery<{
    advanceExternalPaymentVerification: AdvanceExternalPaymentVerificationResult;
  }>({
    query: AdvanceExternalPaymentVerificationQuery,
    requestPolicy: 'network-only',
    variables: {
      input: {
        amount: {
          amount,
          currency: 'USD',
        },
        optionId: optionId,
      },
    },
  });

  const externalPaymentVerification = data?.advanceExternalPaymentVerification;

  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();
  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: () => router.back(),
    },
  };

  const errorModel =
    error?.message ||
    data?.advanceExternalPaymentVerification?.__typename ===
      AdvanceExternalPaymentVerificationResultTypenames.AdvanceExternalPaymentVerificationError
      ? {
          screenType: ErrorScreenType.Error,
          messageHeadline: defaultTitle,
          messageBody: defaultMessage,
          ...buttons,
        }
      : null;

  const institutionName = isExternalPaymentLinkCardType(
    externalPaymentVerification,
  )
    ? (externalPaymentVerification.externalInstitutionName ?? '')
    : '';
  const institutionLastFour = isExternalPaymentLinkCardType(
    externalPaymentVerification,
  )
    ? (externalPaymentVerification.externalInstitutionLastFour ?? '')
    : '';

  return {
    externalPaymentVerification,
    institutionName,
    institutionLastFour,
    loading: fetching,
    error: errorModel,
    refetch,
  };
};
